import { render, staticRenderFns } from "./Notic.vue?vue&type=template&id=62ff2e4d&scoped=true"
import script from "./Notic.vue?vue&type=script&lang=js"
export * from "./Notic.vue?vue&type=script&lang=js"
import style0 from "./Notic.vue?vue&type=style&index=0&id=62ff2e4d&prod&scoped=true&lang=scss"
import style1 from "./Notic.vue?vue&type=style&index=1&id=62ff2e4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ff2e4d",
  null
  
)

export default component.exports